module.exports = function (storePickerPanelService, storePickerService, atm, $state, $rootScope, bwsNotificationService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.storePickerPanelService = storePickerPanelService;

            scope.setDelivery = function () {

                $rootScope.$emit('featurePromo:hideFeaturePromoPanel');

                storePickerService.setDeliveryByStoreNo(storePickerPanelService.deliverySearch.FulfilmentStoreID).then(function () {

                    storePickerService.store = storePickerService.fulfilmentInfo.DeliveryDetails;
                    storePickerService.store.SuburbName = storePickerService.fulfilmentInfo.DeliveryDetails.FulfilmentStoreID;

                    storePickerService.setFulfilmentInfoInLocalStorage(storePickerService.fulfilmentInfo);

                    const atmData = {
                        event: 'BWSAUdeliveryOverlay',
                        store: {
                            DeliveryOverlayAddress: storePickerPanelService.deliverySearch.SuburbName,
                            DeliveryOverlayInteraction: 'click'
                        },
                        fulfilmentInfo: storePickerService.fulfilmentInfo
                    };

                    atm.pushWithStoreMapper(atmData);

                    const updateData = {
                        event: 'BWSAUupdateStorePreference',
                        area: 'Delivery overlay',
                        store: {
                            StoreNo: storePickerService.fulfilmentInfo.DeliveryDetails.FulfilmentStoreID,
                            Postcode: storePickerService.fulfilmentInfo.DeliveryDetails.StoreAddressPostalCode,
                            Name: storePickerService.fulfilmentInfo.DeliveryDetails.FulfilmentStoreName
                        },
                        fulfilmentInfo: storePickerService.fulfilmentInfo
                    };

                    atm.pushWithStoreMapper(updateData);

                    storePickerPanelService.setSuburbInLocalStorage(storePickerPanelService.deliverySearch);
                    scope.storeLocation = storePickerPanelService.deliverySearch;
                    $state.forceReload(); // not a good idea
                    bwsNotificationService.success(`Delivery to <strong>${storePickerPanelService.deliverySearch.SuburbName}</strong> has been set.`);
                });

            };

        },
        template: require('./feature-delivery-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-promo/features/feature-delivery/feature-delivery-directive.js
 **/